import Vue from 'vue'
import Component from './ServiceCategoryPicker.vue'

const Constructor = Vue.extend(Component)

let instance = null

export function pickServiceCategory(selectedId) {
  if (instance) {
    instance.$destroy()
    instance = null
  }

  instance = new Constructor({
    propsData: { value: selectedId },
  })

  instance.$mount()

  return instance.open().finally(() => {
    instance.$destroy()
    instance = null
  })
}
